import axios from '../axios'
import DuplicateEnquiryService from './DuplicateEnquiryService'

/**
 * Branch & Product Analysis (DRAFT), read only.
 *   GET /v1/branchProductAnalysis        { options, cells, window, basis }
 *   GET /v1/branchProductAnalysis/rows   { rows, truncated } for one cell
 * Multi-value filters go as repeated keys (branches=1&branches=2); a dimension left out means All.
 */
export default class BranchProductAnalysisService {
  async getGrid(params) {
    const response = await axios.get('/v1/branchProductAnalysis', {
      params: params || {},
      paramsSerializer: DuplicateEnquiryService.serializeParams
    })
    return response.data || { options: {}, cells: [] }
  }

  async getRows(params) {
    const response = await axios.get('/v1/branchProductAnalysis/rows', {
      params: params || {},
      paramsSerializer: DuplicateEnquiryService.serializeParams
    })
    return response.data || { rows: [], truncated: false }
  }
}
